import {createApp} from 'vue'
import App from './App.vue'
import VueFileAgentNext from '@boindil/vue-file-agent-next'
import '@boindil/vue-file-agent-next/dist/vue-file-agent-next.css'

createApp(App).use(VueFileAgentNext).mount('#app')
